import React, { useRef } from "react"
import isNumeric from "validator/lib/isNumeric"
import { useTranslation } from "react-i18next"

import { getUserList } from "services"
import { Select } from "components"
import { formatMobilePhone } from "utils"
import classes from "./OfsAccessSelect.module.scss"

const OfsAccessSelect = props => {
  const {
    form,
    setForm,
    initialAccessList,
    setInitialAccessList
  } = props

  const [t] = useTranslation()

  const timeout = useRef(null)
  const unmount = useRef(false)

  const getInitialAccessesList = async () => {
    if (initialAccessList !== null) return

    try {
      const { data } =
        await getUserList({ limit: 5, role: "access" })

      if (unmount.current) return

      setInitialAccessList(
        data.map(access => ({
          value: access._id,
          label: `${access.fullName} ${access.mobilePhone ? `(${formatMobilePhone(access.mobilePhone)})` : ""}`
        }))
      )

    } catch (err) {
      console.log(err)
    }
  }

  const handleSelect = (select) => {
    setForm(prev => ({
      ...prev,
      addedByAccount: select
    }))
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const queries = {
          role: "access",
          limit: 5,
        }

        if (isNumeric(inputValue)) {
          queries.mobilePhone =
            inputValue[0] === "0"
              ? inputValue.substring(1)
              : inputValue
        } else {
          queries.fullName = inputValue

          queries.username = inputValue
        }

        const { data: users } =
          await getUserList(queries)

        callback(
          users.map(user => ({
            label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
            value: user._id
          }))
        )
      }, 600)
  }

  return (
    <div className={classes["container"]}>
      <Select
        async
        isClearable
        label={t("جست_و_جو_طریق_سفارش")}
        loadOptions={handleSearch}
        value={form.addedByAccount}
        noOptionsMessage={() => null}
        onChange={handleSelect}
        defaultOptions={initialAccessList}
        onFocus={getInitialAccessesList}
      />
    </div>
  )
}

export default OfsAccessSelect